﻿<script>
    import { Router, Route, navigate } from "svelte-navigator";

    import FormColumn from "../components/FormColumn.svelte";
    import LandingPage from "./Registration/LandingPage.svelte";
    import PersonalDetails from "./Registration/PersonalDetails.svelte";
    import Confirmation from "./Registration/Confirmation.svelte";
    import Review from "./Registration/Review.svelte";
    import ThankYou from "./Registration/ThankYou.svelte";

    import Error from "./Error.svelte";
    import NavTracker from "../components/NavTracker.svelte";
    import ClaimDetails from './Registration/ClaimDetails.svelte';

    export let url = "";
    export let basepath = "/";

    const registrationPageList = [
        {
            pageIndex: 0,
            pageTitle: `${projectSettings.classActionName}`,
            title: "Claimant Registration Form",
            showInTracker: true,
            lastVisitedPage: "Landing Page",
            nextPage: "/Registration/PersonalDetails",
            routeId: "/Registration",
        },
        {
            pageIndex: 1,
            title: "Personal Details",
            showInTracker: true,
            pageTitle: `${projectSettings.classActionName} - Personal Details`,
            nextPage: "/Registration/ClaimDetails",
            previousPage: "/Registration",
            persistUrl: "api/project",
            lastVisitedPage: "Personal Details",
            routeId: "/Registration/PersonalDetails",
        },
        {
            pageIndex: 2,
            title: "Claim Details",
            showInTracker: true,
            pageTitle: `${projectSettings.classActionName} - Claim Details`,
            nextPage: "/Registration/Confirmation",
            previousPage: "/Registration/PersonalDetails",
            persistUrl: "api/project",
            lastVisitedPage: "Claim Details",
            routeId: "/Registration/ClaimDetails",
        },
        {
            pageIndex: 3,
            title: "Confirmation",
            showInTracker: true,
            pageTitle: `${projectSettings.classActionName} - Confirmation`,
            previousPage: "/Registration/ClaimDetails",
            nextPage: "/Registration/ThankYou",
            nextPageLabel: "Submit",
            persistUrl: "api/registration",
            lastVisitedPage: "Confirmation",
            routeId: "/Registration/Confirmation",
        },
        {
            pageIndex: 4,
            title: "Thank you",
            showInTracker: true,
            pageTitle: `${projectSettings.classActionName} - Thank you`,
            routeId: "/Registration/ThankYou",
        },
        {
            pageIndex: 5,
            title: "Review",
            showInTracker: false,
            pageTitle: `${projectSettings.classActionName} - Review`,
            routeId: "/Review",
        },
        {
            pageIndex: 6,
            title: "Error",
            showInTracker: false,
            pageTitle: `${projectSettings.classActionName} - Error`,
            routeId: "/Error",
        },
    ];

    let trackerPageList = registrationPageList;

    const checkLandingUrl = function () {

        if (window.location.pathname.indexOf('/Registration') >= 0 && window.location.pathname !== '/Registration') {
            navigate('/Registration');
            return false;
        } else if (window.location.pathname.indexOf('/Registration') < 0 &&
            window.location.pathname.indexOf('/Review') < 0) {
            navigate('/Registration');
            return false;
        }

        return true;
    }

    if (checkLandingUrl()) {
        window.onbeforeunload = (event) => {
            event.returnValue = `Are you sure you want to leave?`;
        };
    }

</script>

<Router {url} {basepath}>
<div class="row">
    <FormColumn cols="2"></FormColumn>
    <FormColumn cols="8">
        <NavTracker pageList="{trackerPageList}" />

        <Route path="/">
            <LandingPage {...registrationPageList[0]}></LandingPage>
        </Route>
        <Route path="Registration">
            <LandingPage {...registrationPageList[0]}></LandingPage>
        </Route>
        <Route path="Registration/PersonalDetails">
            <PersonalDetails {...registrationPageList[1]}></PersonalDetails>
        </Route>
        <Route path="Registration/ClaimDetails">
            <ClaimDetails {...registrationPageList[2]}></ClaimDetails>
        </Route>
        <Route path="Registration/Confirmation">
            <Confirmation {...registrationPageList[3]}></Confirmation>
        </Route>
        <Route path="Registration/ThankYou">
            <ThankYou {...registrationPageList[4]}></ThankYou>
        </Route>

        <Route path="Review" component="{Review}" {...registrationPageList[5]}/>
        <Route path="*/Error" component="{Error}" {...registrationPageList[6]}/>
    </FormColumn>
    <FormColumn cols="2"></FormColumn>
</div>
</Router>
